module.exports = __webpack_public_path__ + "static/media/dashboard-1.d0f0e398.svg";